import { createStyles } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = () =>
  createStyles({
    root: {
      fontSize: 17,
      fill: colors.white.lightest,
    },
  });
